import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";
import { TiptapEditor } from "../../Tiptap/TiptapEditor";
import { tipTapEditorDefault } from "../../../services/validationRules";

export default function MessageFormEditor() {
  return (
    <>
      <Grid size={12}>
        <Typography variant={"body2"}>
          Bitte geben Sie hier Ihre Nachricht ein. Sie haben im nächsten Schritt noch die Möglichkeit Ihrer Nachricht Dateien anzuhängen.
        </Typography>
      </Grid>
      <Grid size={12} sx={{ marginTop: "0.5rem" }}>
        <TiptapEditor name={"message"} validators={tipTapEditorDefault(20, 5000)} maxCharacterLength={5000} />
      </Grid>
    </>
  );
}
